// ══════════════════════════════════════════════════════════════════════════════
//  La tecla de un bloque (2026-10-08). El panel en bloques de tecla (lienzo "La
//  barra superior", página "El panel", B) y la lista de reportes de la libreta de
//  compactaciones agrupan sus filas en TECLAS: el blanco de las teclas de la barra
//  superior, su filo y su sombra de contacto (`GLASS.tecla`), con 3 px de relleno;
//  lo activo es el relleno claro de dentro (`C.primaryLight`). El rótulo del
//  bloque va fuera, sobre el tono del panel. Pieza mínima a propósito: el panel
//  vive en el chunk del shell.
// ══════════════════════════════════════════════════════════════════════════════
import { C, R, GLASS } from '../../design.js';

export const RELLENO_TECLA = 3;
// El radio de una fila dentro de la tecla: el de la tecla menos su relleno, para que
// las esquinas de lo activo sigan a las de la tecla.
export const RADIO_FILA_EN_TECLA = R.xl - RELLENO_TECLA;

export function BloqueTecla({ children }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 1, padding: RELLENO_TECLA, borderRadius: R.xl, ...GLASS.tecla, flexShrink: 0 }}>
      {children}
    </div>
  );
}

// El rótulo de un bloque: el Rótulo del lenguaje en calma (components/carpeta/
// piezas.js), escrito aquí para no traer sus vecinos al chunk del shell.
export const ROTULO_BLOQUE = { fontSize: 11, fontWeight: 600, letterSpacing: '0.13em', textTransform: 'uppercase', color: C.textMuted, whiteSpace: 'nowrap' };
